import React from "react";
import { Box, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

const HeaderPages = ({
  title,
  hasButton,
  buttonHref,
  isBackButton,
  buttonTitle,
}) => {
  const navigate = useNavigate();

  return (
    <Stack
      width={"100%"}
      direction={"row"}
      justifyContent={"space-between"}
      display={"flex"}
      alignItems={"center"}
    >
      <Box>
        <h1>{title}</h1>
      </Box>
      {hasButton ? (
        <Box>
          <Button
            onClick={() => {
              if (isBackButton) {
                navigate(-1);
              } else {
                navigate(buttonHref);
              }
            }}
            color="success"
            variant="contained"
          >
            {isBackButton ? "Voltar" : buttonTitle}
          </Button>
        </Box>
      ) : null}
    </Stack>
  );
};

export default HeaderPages;
